import React from 'react';
import ServiceEntryFilters from './ServiceEntryFilters';
import { useIntl } from 'react-intl';
import Signals from '../../../signals/Signals';
import CreateManualServiceEntryOverlay from './CreateManualServiceEntryOverlay';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
export default function ServiceEntriesControls(props) {
    var serviceEntryCollection = props.serviceEntryCollection, hideSearchControls = props.hideSearchControls, hideFilters = props.hideFilters, hideCreateManual = props.hideCreateManual, children = props.children;
    var intl = useIntl();
    return React.createElement("div", { className: "service-entries-controls d-flex flex-column justify-content-end flex-md-row" },
        React.createElement("div", { className: "d-flex justify-content-between flex-shrink-0 my-3 mt-md-0 flex-fill flex-wrap button-grid" },
            hideFilters ? React.createElement("div", null) :
                React.createElement(ServiceEntryFilters, { serviceEntryCollection: serviceEntryCollection }),
            React.createElement("div", { className: "d-flex flex-nowrap justify-content-end button-grid" },
                !hideCreateManual &&
                    React.createElement("div", { className: "nav btn-group h-100" },
                        React.createElement("button", { className: "btn btn-white", type: "button", id: "createManualAssetButton", title: intl.formatMessage({ id: 'manual.serviceentry.create.label' }), onClick: function () {
                                Signals.ShowOverlay.dispatch(React.createElement(CreateManualServiceEntryOverlay, null));
                            } },
                            React.createElement("span", { className: "fe fe-plus-circle" }))),
                children)));
}
